import React from 'react';
import { useAuth } from '../contexts/AuthContext';

function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Single comment row. Shows delete button if owner or admin.

export default function CommentItem({ comment, onDelete }) {
  const { user, isAdmin } = useAuth();
  const userSub = user?.userId || user?.username;
  const canDelete = userSub === comment.authorSub || isAdmin;

  return (
    <div style={{
      padding: '14px 16px',
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      marginBottom: 8,
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        marginBottom: 8, fontSize: '0.85rem',
      }}>
        <span style={{ fontWeight: 600 }}>{comment.nickname || '익명'}</span>
        <span style={{ color: 'var(--text-dim)' }}>
          {formatDate(comment.createdAt)}
        </span>
      </div>
      <p style={{
        margin: 0, fontSize: '0.95rem', lineHeight: 1.6,
        whiteSpace: 'pre-wrap', wordBreak: 'break-word',
      }}>
        {comment.body}
      </p>
      {canDelete && (
        <div style={{ marginTop: 10, textAlign: 'right' }}>
          <button
            type="button"
            onClick={() => onDelete(comment.commentId)}
            style={{
              background: 'none', border: '1px solid #ff5252',
              color: '#ff5252', cursor: 'pointer',
              fontSize: '0.82rem', padding: '6px 14px',
              borderRadius: 6, minHeight: 32,
            }}
          >
            삭제
          </button>
        </div>
      )}
    </div>
  );
}
